<template>
  <div
    class="
      login
      is-flex
      is-flex-direction-column
      is-justify-content-center
      is-align-items-center
    "
  >
    <div
      class="
        is-flex
        is-flex-direction-column
        is-align-items-center
        is-justify-content-center
      "
    >
      <img alt="movida logo" src="@/assets/logo.svg" />
      <h1 class="is-size-2 has-text-weight-bold pb-5">{{ appTitle }}</h1>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="content">
          <form autocomplete="off" @submit.prevent="submit()">
            <b-field class="has-text-left" label="Usuário">
              <b-input
                v-model="form.username"
                autocomplete="nope"
                placeholder="Insira um usuario Movida"
                maxlength="30"
                ref="username">
              </b-input>
            </b-field>

            <b-field class="has-text-left pb-4" label="Senha">
              <b-input
                v-model="form.password"
                type="text"
                id="password"
                name="password"
                placeholder="Insira sua senha"
                autocomplete="off"
              ></b-input>
            </b-field>
            
            <b-field class="has-text-right pb-4">
              <a @click="forgotPass" class="forgot"> Esqueci a senha </a>
            </b-field>

            <div class="buttons">
              <b-button
                class="is-fullwidth"
                label="Entrar"
                type="is-primary"
                native-type="submit"
                icon-left="check"
                :disabled="!recaptchaLoaded || isSubmitting"
                :loading="isSubmitting"
              />

            </div>
          </form>
        </div>
        <b-loading
          :is-full-page="isFullPage"
          v-model="isLoading"
          :can-cancel="true"
        ></b-loading>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/styles/LoginView.css";
import state from "@/modules/auth/store/state";
import services from '@/http';
import { flash } from "@/mixins/flash";
import { redirectMixin } from "@/mixins/redirectMixin";
import Footer from '@/components/Layout/FooterLogin.vue';
import jwt_decode from 'jwt-decode';
import pako from 'pako';
import { inferAppParamFromAcs } from '@/modules/auth/inferAppParamFromAcs';

export default {
  components: {
    Footer
  },

  mixins: [flash,redirectMixin],
  data: () => ({
    isLoading: false,
    isFullPage: true,
    isRedirect: false,
    isSAML: false,
    isAllowedOrigin: false,
    redirectTo:"",
    allowedOrigins: process.env.VUE_APP_ALLOWED_ORIGINS_REDIRECT,
    appTitle: process.env.VUE_APP_TITLE,
    recaptcha_key: process.env.VUE_APP_KEY_RECAPTCHA,
    redirect: false,
    recaptchaLoaded: false,
    isSubmitting: false,
    form: {
      username: "",
      password: "",
    },
    userId: state.user.id,
    params: {},
    appParam:"",
    samlRequest:"",
    relayState:"",
    papeisSemMfa: process.env.VUE_APP_PAPEIS_NOT_MFA ? process.env.VUE_APP_PAPEIS_NOT_MFA.split(',').map(Number) : []
  }),
  mounted() {  
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      `https://www.google.com/recaptcha/enterprise.js?render=${this.recaptcha_key}`
    );
    
    // Atributos de otimização e segurança
    recaptchaScript.async = true;  // Carregamento assíncrono
    recaptchaScript.defer = true;  // Execução após DOM pronto
    
    // Listener para quando o script carregar com sucesso
    recaptchaScript.onload = () => {
      this.recaptchaLoaded = true;
    };
    
    // Tratamento de erro se o script falhar ao carregar
    recaptchaScript.onerror = () => {
      console.error('Falha ao carregar reCAPTCHA');
      this.flashError('Erro ao carregar sistema de segurança. Por favor, recarregue a página.', 'is-bottom', 5000);
    };
    
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    forgotPass(){
      this.$router.push("/forgot-password").catch(()=>{});
    },
    submit(){
      // Previne múltiplos submits
      if (this.isSubmitting) {
        return;
      }
      
      // Verifica se o reCAPTCHA está carregado
      if (typeof grecaptcha === 'undefined' || !this.recaptchaLoaded) {
        this.flashError('Por favor, aguarde o carregamento completo da página.', 'is-bottom', 3000);
        return;
      }
      
      this.isSubmitting = true;
      this.params = new URL(location.href).searchParams;

      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(this.recaptcha_key, {
            action: "login",
          });

          this.isRedirect = window.location.search.includes("redirect_to=");
        if (this.isRedirect) {
          this.redirectTo = this.params.get("redirect_to");
        }
        this.isSAML = window.location.search.includes("SAMLRequest="); 

        if (this.isSAML){
          this.form.SAMLRequest = this.params.get("SAMLRequest");
          this.form.RelayState = this.params.get("RelayState");
          const appParamFromQuery = this.params.get("appParam") || "";

          const decoded = atob(this.form.SAMLRequest); 
          const charData = decoded.split('').map(c => c.charCodeAt(0));
          const binData = new Uint8Array(charData);
          const inflated = pako.inflateRaw(binData, { to: 'string' });
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(inflated, "text/xml");
          const rootElement = xmlDoc.documentElement;
          const acsUrl = rootElement.getAttribute("AssertionConsumerServiceURL");

          this.form.appParam = inferAppParamFromAcs(acsUrl, appParamFromQuery);
        }

        this.form.recaptcha = token;
        this.isLoading = true;        

          this.login(this.form)
            .catch((err) => {
              this.isLoading = false;
              this.isSubmitting = false;
              this.flashError(err, "is-bottom", 5000);
            });
        } catch (error) {
          console.error('Erro no reCAPTCHA:', error);
          this.flashError('Erro na verificação de segurança. Tente novamente.', 'is-bottom', 5000);
          this.isSubmitting = false;
        }
      });
    },
    login(payload) {
          const appRequest = {
            grant_type: process.env.VUE_APP_GRANT_TYPE,
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET
          };

          return services.auth.app(appRequest)
          .catch(err => {
            // Tratamento específico para timeout na autenticação da aplicação
            if (err.statusText === 'Timeout' || err === 'Timeout' || err.message?.includes('Tempo limite')) {
              throw new Error('Tempo limite de conexão excedido. Verifique sua conexão e tente novamente.');
            }
            throw err;
          })
          .then(res => {
            this.$store.dispatch('auth/ActionSetToken', {
              token: res.body.data.access_token,
              expiresIn: res.body.data.expires_in,
            });

            const request = {
              login: payload.username,
              password: payload.password,
              recaptcha: payload.recaptcha
            };

            if (payload.SAMLRequest) {
              request.SAMLRequest = payload.SAMLRequest;
              request.RelayState = payload.RelayState;
              request.appParam = payload.appParam;
            }

            const endpoint = payload.SAMLRequest ? 
              process.env.VUE_APP_BFF_URL + 'v1/movida/user/login' : 
              process.env.VUE_APP_BFF_URL + 'v1/movida/user/login_sec';

            return this.$http.post(endpoint, request, {
              headers: {
                Authorization: `Bearer ${$cookies.get("token_app")}`
              },
              timeout: 30000 // 30 segundos
            })
            .catch(err => {
              // Tratamento específico para timeout no login do usuário
              if (err.statusText === 'Timeout' || err === 'Timeout' || err.message?.includes('Tempo limite')) {
                throw new Error('Tempo limite de conexão excedido. Verifique sua conexão e tente novamente.');
              }
              throw err;
            })
            .then(res => {
              const params = new URL(location.href).searchParams;
              this.isLoading = false;

              if (res.body.data.SAMLResponse) {
                this.$store.dispatch('auth/ActionSetSAML', {
                  SAMLResponse: res.body.data.SAMLResponse,
                  RelayState: res.body.data.RelayState,
                });

                // Decodifica o token JWT para verificar as informações MFA
                const decodedToken = jwt_decode(res.body.data.token);
                const hasMfaConfigured = decodedToken.mfa_ativo && decodedToken.mfa_padrao && decodedToken.mfa_padrao.MfaMetodoID;

                // NextQS: sempre exige MFA quando o usuário tem MFA configurado, independente de mfa_enable ou papeisSemMfa
                if (payload.appParam === 'nextqs' && hasMfaConfigured) {
                  this.$store.dispatch('auth/ActionSetTokenUser', {
                    token: res.body.data.token,
                    expiresIn: res.body.data.expires_in,
                    mfa_ativo: decodedToken.mfa_ativo,
                    mfa_padrao: decodedToken.mfa_padrao,
                    outros_metodos_mfa: decodedToken.outrosMetodosMfa,
                    confirmar_email: decodedToken.confirmar_email,
                    confirmar_celular: decodedToken.confirmar_celular,
                  });
                  sessionStorage.setItem("SAMLResponse", res.body.data.SAMLResponse);
                  sessionStorage.setItem("RelayState", res.body.data.RelayState);
                  sessionStorage.setItem("destination", res.body.data.destination);
                  this.$router.push({
                    path: '/validTokenMfa',
                    query: {
                      isSAML: true,
                      destination: res.body.data.destination
                    }
                  }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      console.error('Erro na navegação:', err);
                    }
                  });
                  return;
                }

                // Verifica se a aplicação tem MFA habilitado (mfa_enable)
                if (decodedToken.mfa_enable) {
                  // Verifica se o usuário é RPA ou se a aplicação não tem MFA habilitado.
                  // Para NextQS (appParam === 'nextqs') não aplicamos a exceção de papel: sempre exige MFA se o usuário tiver configurado.
                  const skipMfaByRole = this.papeisSemMfa.includes(decodedToken.papelID) && payload.appParam !== 'nextqs';
                  if (skipMfaByRole) {
                    // Se for RPA (e não NextQS), redireciona direto sem MFA
                    this.handleSAMLRedirect(res.body.data);
                  }
                  // Se a aplicação tem MFA habilitado, verifica se o usuário tem métodos MFA
                  else if (hasMfaConfigured) {
                    // Se o usuário tem MFA configurado, redireciona para validação
                    this.$store.dispatch('auth/ActionSetTokenUser', {
                      token: res.body.data.token,
                      expiresIn: res.body.data.expires_in,
                      mfa_ativo: decodedToken.mfa_ativo,
                      mfa_padrao: decodedToken.mfa_padrao,
                      outros_metodos_mfa: decodedToken.outrosMetodosMfa,
                      confirmar_email: decodedToken.confirmar_email,
                      confirmar_celular: decodedToken.confirmar_celular,
                    });

                    // Armazena os dados do SAML no sessionStorage
                    sessionStorage.setItem("SAMLResponse", res.body.data.SAMLResponse);
                    sessionStorage.setItem("RelayState", res.body.data.RelayState);
                    sessionStorage.setItem("destination", res.body.data.destination);

                    this.$router.push({
                      path: '/validTokenMfa',
                      query: {
                        isSAML: true,
                        destination: res.body.data.destination
                      }
                    }).catch(err => {
                      // Ignora erros de navegação duplicada, mas loga outros erros
                      if (err.name !== 'NavigationDuplicated') {
                        console.error('Erro na navegação:', err);
                      }
                    });
                  } else {
                    // Se a aplicação tem MFA mas o usuário não tem métodos configurados
                    this.handleSAMLRedirect(res.body.data);
                  }
                } else {
                  // Se a aplicação não tem MFA habilitado, faz o redirecionamento SAML normal
                  this.handleSAMLRedirect(res.body.data);
                }
              } else {
                // Login normal da aplicação (não SAML)
                const decodedToken = jwt_decode(res.body.data.token);

                this.$store.dispatch('auth/ActionSetTokenUser', {
                  token: res.body.data.token,
                  expiresIn: res.body.data.expires_in,
                  mfa_ativo: decodedToken.mfa_ativo,
                  mfa_padrao: decodedToken.mfa_padrao,
                  outros_metodos_mfa: decodedToken.outrosMetodosMfa,
                  confirmar_email: decodedToken.confirmar_email,
                  confirmar_celular: decodedToken.confirmar_celular,
                });

                this.$store.dispatch('auth/ActionLoadSession');
                
                this.$store.dispatch('auth/ActionSetRedirect', {
                  redirect: this.isRedirect,
                  redirect_to: this.redirectTo,
                  params: params,
                  allowedOrigins: this.allowedOrigins
                });
                

                // Verifica se o usuário é RPA
                if (this.papeisSemMfa.includes(decodedToken.papelID)) {
                  // Se for RPA, redireciona direto sem MFA
                  this.redirectPage();
                } 
                // Para usuários da aplicação, verifica se tem MFA ativo
                else if(decodedToken.mfa_ativo && decodedToken.mfa_padrao && decodedToken.mfa_padrao.MfaMetodoID) {
                  this.$router.push({
                    path: '/validTokenMfa'
                  }).catch(err => {
                    // Ignora erros de navegação duplicada, mas loga outros erros
                    if (err.name !== 'NavigationDuplicated') {
                      console.error('Erro na navegação:', err);
                    }
                  });
                } else {
                  this.redirectPage();
                }
              }
            });
      });
    },
    handleSAMLRedirect(data) {
      if (data.destination) {
        this.postSAML(data.destination, {
          SAMLResponse: data.SAMLResponse,
          RelayState: data.RelayState
        });
      } else {
        this.flashError('URL de destino inexistente', "is-bottom", 5000);
      }
    },
    postSAML(path, params, method='post') {
      // The rest of this code assumes you are not using a library.
      // It can be made less verbose if you use one.
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    }
  },
};
</script>